module.exports = __webpack_public_path__ + "static/media/georgi.f14103c5.jpg";